var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMentorleft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    cliipRule: "evenodd",
    d: "M2.54636 6L6.48151 2.06485C6.8395 1.70687 6.8395 1.12647 6.48151 0.768485C6.12353 0.410505 5.54313 0.410505 5.18515 0.768485L0.601819 5.35182C0.243838 5.7098 0.243838 6.2902 0.601819 6.64818L5.18515 11.2315C5.54313 11.5895 6.12353 11.5895 6.48151 11.2315C6.8395 10.8735 6.8395 10.2931 6.48151 9.93515L2.54636 6Z",
    fill: "#44444F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorleft);
export default __webpack_public_path__ + "static/media/mentorleft.5523235d198b12cf3b096ae3910aebda.svg";
export { ForwardRef as ReactComponent };